import React from 'react';
import { useAuth } from '../../../providers/auth';
import CardContainer from '../AdminMetricDashboard/CardContainer';
import EmployersPlans from './A_Components/EmployersPlans';
import EmployerPlanCharts from './A_Components/EmployerPlanCharts';
import { useEmployerAndPlans } from '../../../data/dashboardInightHub';
import { formatFirestoreTStoDate, formatUSNumber } from '../AdminInsighthub/helper';

const SAdminInsightHub = () => {

  const { data } = useEmployerAndPlans("employer_and_plan")

  function formatPlanDistribution(data: any) {
    // Define the initial structure
    const planDistribution = {
      single: { plan: "Single Plan", count: 0 },
      monthly: { plan: "Monthly Plan", count: 0 },
      annual12: { plan: "Annual Flex 12 Plan", count: 0 },
      annual24: { plan: "Annual Flex 24 Plan", count: 0 },
      annual: { plan: "Custom Annual Plan", count: 0 },
    };

    // Loop through each record and increment based on type
    data?.forEach((item: any) => {
      const type = item.type?.toLowerCase();

      if (type === "single") planDistribution.single.count++;
      else if (type === "monthly") planDistribution.monthly.count++;
      else if (type === "annual12") planDistribution.annual12.count++;
      else if (type === "annual24") planDistribution.annual24.count++;
      else if (type === "annual") planDistribution.annual.count++;
    });

    // Convert the object values into an array
    return Object.values(planDistribution);
  }

  // Example usage:
  const formattedData = formatPlanDistribution(data?.recentPayments);
  const lastUpdatedAt = formatFirestoreTStoDate(data?.updatedAt);


  return (
    <div className='bg-white pr-5'>
      <div className="flex justify-between items-center">
        <h2 className="text-2xl text-instant-teams-blue-Main font-bold text-foreground">Employers & Plans</h2>
        {lastUpdatedAt && <p className='text-instant-teams-blue-Main text-lg font-semibold'>{`Last updated: ${lastUpdatedAt}`}</p>}
      </div>
      <div className='rounded-lg  mt-3 bg-white border p-6 bg-card text-card-foreground shadow-sm'>
        <h2 className="text-[22px] mb-4 text-instant-teams-blue-Main font-bold text-foreground">Summary</h2>
        <div className="grid gap-4 grid-cols-2">
          <div className="space-y-2">
            <p className="text-lg text-gray-500 text-muted-foreground">Total Employers</p>
            <p className="text-3xl text-instant-teams-blue-Main font-bold">{formatUSNumber (data?.summary?.totalEmployers ||0)|| ""}</p>
          </div>
          <div className="space-y-2">
            <p className="text-lg text-gray-500 text-muted-foreground">Active Employers</p>
            <p className="text-3xl  text-instant-teams-blue-Main font-bold">{formatUSNumber(data?.summary?.activeEmployers||0) || ""}</p>
          </div>
        </div>
      </div>

      <div className='mt-3'>
        <EmployersPlans planDetails={data?.plans || {}} />
      </div>

      <div>
        <EmployerPlanCharts planDetails={data?.plans} last30DaysSubscription={formattedData} />
      </div>
    </div>
  );
}

export default SAdminInsightHub;
